import {
  SET_TRAINER_DASHBOARD_CARD_DATA,
  SET_TRAINER_DASHBOARD_LIVE_DATA,
  SET_TRAINER_DASHBOARD_WEEKLY_SCHEDULE,
} from "../../actions/types/types";

const initState = {
  cardData: {},
  liveClassCardData: {},
  trainerDashboardWeeklySchedule:undefined
};

const TrainerDashboardReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_TRAINER_DASHBOARD_CARD_DATA:
      return {
        ...state,
        cardData: action.payload.data,
      };
    case SET_TRAINER_DASHBOARD_LIVE_DATA:
      return {
        ...state,
        liveClassCardData: action.payload.data,
      };
    case SET_TRAINER_DASHBOARD_WEEKLY_SCHEDULE:
      return {
        ...state,
        trainerDashboardWeeklySchedule: {data:action.payload.data.scheduleForWeek, totalClasses:action.payload.data.totalClasses, totalAppointments:action.payload.data.totalAppointments},
      };
    default:
      return { ...state };
  }
};

export default TrainerDashboardReducer;
